
import { Search } from "../../../assets/icons";

export default function CatalogEmptyState({
	message,
	hint,
	actionLabel,
	onAction,
}) {
	return (
		<div
			className="relative overflow-hidden rounded-[16px] border border-dashed border-darkBlue/20 bg-gradient-to-br from-white via-lightCta/50 to-white px-6 py-10 md:py-12 text-center shadow-[0_6px_20px_rgba(39,106,166,0.06)]"
			role="status"
		>
			<div
				className="pointer-events-none absolute -left-8 -top-8 h-24 w-24 rounded-full bg-cta/10 blur-2xl"
				aria-hidden
			/>
			<div
				className="pointer-events-none absolute -bottom-10 -right-6 h-28 w-28 rounded-full bg-darkBlue/10 blur-2xl"
				aria-hidden
			/>

			<div className="relative mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-lightCta to-white ring-2 ring-darkBlue/15 shadow-inner">
				<span className="text-darkBlue/70 scale-110">
					<Search />
				</span>
				<span
					className="absolute -bottom-0.5 -left-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-cta text-[13px] font-Vazir-700 text-white shadow-md"
					aria-hidden
				>
					؟
				</span>
			</div>

			<p className="relative font-Vazir-600 text-[16px] md:text-[17px] text-darkBlue leading-relaxed">
				{message}
			</p>
			{hint && (
				<p className="relative mt-2 max-w-md mx-auto font-Vazir-400 text-[13px] md:text-[14px] text-darkBlue/55 leading-relaxed">
					{hint}
				</p>
			)}
			{actionLabel && onAction && (
				<button
					type="button"
					onClick={onAction}
					className={[
						"relative mt-5 inline-flex items-center justify-center rounded-[10px] px-4 py-2",
						"font-Vazir-600 text-[13px] text-darkBlue",
						"border border-darkBlue/25 bg-white",
						"transition hover:border-cta/50 hover:text-cta",
						"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cta/30",
					].join(" ")}
				>
					{actionLabel}
				</button>
			)}
		</div>
	);
}
